











































































import {Component, Prop, Vue} from "vue-property-decorator";
import VueError from "@/components/VueError.vue";
import TimestampAgo from "@/components/TimestampAgo.vue";
import {curNtagClient, MoveEvent, NtagClient} from "@/services/NtagClient";
import CustomSectionHeader from "@/components/CustomSectionHeader.vue";
import Loading from "@/components/Loading.vue";
import * as _ from "lodash";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import { Device } from '@/types/core';
import { NTag } from '@/types/ntag';
import moment from "moment";
import fileDownload from "js-file-download";

@Component({
  components:{
    VueError,
    TimestampAgo,
    CustomSectionHeader,
    Loading,
  }
})
export default class LocationMovementsHistoryTable extends Vue {

  @Prop({ default: {},  type: Object}) tag!: NTag;

  error:string = '';
  httpBusy:boolean = false;
  offset = 0;
  itemsPerPage = 10;
  dbItemsList:MoveEvent[] = [];
  itemsList:MoveEvent[] = [];

  // internal dependencies
  private ntagClient:NtagClient = curNtagClient;
  private coreClient:CoreClient = curCoreClient;

  async mounted() {
    this.loadNtagMovementsHistory();
  }

  async loadNtagMovementsHistory() {

    this.httpBusy = true;
    this.error = '';

    const reply = await this.ntagClient.getTagMovementsHistory(this.tag.id);

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve movements for tag ${this.$route.params.id}: ${reply.errorMsg}`;

    this.dbItemsList = _.reverse(_.sortBy(reply.movements, 'ts'));

    this.dbItemsList = this.dbItemsList;

    this.offset = 0;
    this.refreshMovementsList();
  }

  refreshMovementsList() {
    this.itemsList = this.dbItemsList.slice(this.offset, this.offset+this.itemsPerPage);
  }

  goBack() {
    this.offset+=this.itemsPerPage;
    this.refreshMovementsList();
  }

  goForward() {
    this.offset-=this.itemsPerPage;
    this.refreshMovementsList();
  }

  getEnterprise(item: MoveEvent): string {
    return item.location ? item.location.enterpriseId.replace(/^nnn\./,'') : '';
  }

  getLocationInfo(item: MoveEvent) {
    return item.location ? `${item.location.name}` : '';
  }

  renderDescription(item: MoveEvent): string {
    switch (item.cause) {
      case "new_location":
        return 'first transmission via location';
      case "unknown_base_station":
        return 'transmission via non N-tag registered location';
      case "missed_uplinks":
        return 'several uplinks missed in this location';
    }
  }

  exportHistory() {
    const csvExport = this.movementsToCSV(this.dbItemsList.concat());

    const filename = `export-ntag-${this.tag.id}-movement-history-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  private movementsToCSV(moveEvents: MoveEvent[]): string {
    const retList:string[] = [];

    retList.push(`tagId,eventTime,outEstimationTs,lastOnlineInLocationTs,locationEnterpriseId,locationName,direction,cause,numberOfEventsSameLocation`);

    const compressedMoveEvents = this.compressMoveEvents(_.filter(moveEvents, (moveEvent) => moveEvent.ts > 1648731600000));

    for(const moveEvent of compressedMoveEvents) {

      const row = [];
      row.push(this.forceString(moveEvent.tagId));
      row.push(moment(moveEvent.ts).format());
      row.push(moveEvent.outEstimationTs ? moment(moveEvent.outEstimationTs).format() : '');
      row.push(moveEvent.lastOnlineInLocationTs ? moment(moveEvent.lastOnlineInLocationTs).format() : '');
      row.push(this.forceString(moveEvent.location.enterpriseId.replace(/^nnn\./, '')));
      row.push(this.forceString(moveEvent.location.name));
      row.push(this.forceString(moveEvent.type));
      row.push(this.forceString(this.renderCause(moveEvent.cause)));
      row.push(moveEvent.compressionNumber);

      retList.push(row.join(','));
    }

    return retList.join("\n");
  }

  private compressMoveEvents(moveEvents: MoveEvent[]): MoveEvent[] {
    let chainOfEvents: MoveEvent[] = [];
    const compressed: MoveEvent[] = [];
    for ( let i = moveEvents.length - 1; i >= 0; i-- ) {
      if ( chainOfEvents.length > 0 && moveEvents[i].locationId !== chainOfEvents[chainOfEvents.length - 1].locationId) {
        compressed.push(chainOfEvents[0]);
        if ( chainOfEvents.length - 1 > 0 ) {
          chainOfEvents[chainOfEvents.length - 1].compressionNumber = chainOfEvents.length;
          compressed.push(chainOfEvents[chainOfEvents.length - 1]);
        }
        chainOfEvents = [];
      }
      chainOfEvents.push(moveEvents[i]);
    }

    if ( chainOfEvents.length > 0 ) {
      compressed.push(chainOfEvents[0]);
      if ( chainOfEvents.length - 1 > 0 ) {
        chainOfEvents[chainOfEvents.length - 1].compressionNumber = chainOfEvents.length;
        compressed.push(chainOfEvents[chainOfEvents.length - 1]);
      }
    }

    return compressed;
  }

  private renderCause(cause:'missed_uplinks' | 'new_location' | 'unknown_base_station'):string {
    if ( cause === 'new_location' ) {
      return 'new_transmission';
    } else if ( cause === 'unknown_base_station') {
      return 'transmission_via_non_ntag_registered_location';
    }
    return cause;
  }

  private forceString(data:string):string {
    return `"${data}"`;
  }

  get showItemsTable() {
    return !this.httpBusy && this.itemsList.length > 0;
  }
  get showItemsNav() {
    return !this.httpBusy && this.itemsList.length > 0;
  }

  get showNoItems() {
    return !this.httpBusy && this.itemsList.length === 0;
  }

  get olderItemsEnabled() {
    return (this.offset + this.itemsPerPage) < this.dbItemsList.length;
  }

  get newerItemsEnabled() {
    return this.offset > 0;
  }
}
